import(/* webpackMode: "eager", webpackExports: ["ConfigProvider"] */ "__barrel_optimize__?names=ConfigProvider!=!/vercel/path0/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Nunito\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"900\"],\"display\":\"swap\"}],\"variableName\":\"nunito\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/horizontal-color-cropped.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/background-parallax/bg-parallax.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/footer/social-icons.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/footer/footer.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ToasterContainer"] */ "/vercel/path0/src/components/layout/toast/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StyleControlsProvider"] */ "/vercel/path0/src/hooks/useStyleController.hook.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ParallaxProvider"] */ "/vercel/path0/src/providers/parallax.provider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.scss");
